<template>
  <div>
    <CreateFilterGroup
      v-if="showCreateModal"
      @close="showCreateModal = false"
    />
    <FilterLabels
      :filters="allFilters"
      @removeFilter="onRemoveFilter"
    />
    <BaseText
      @click="onToggleFilters"
      v-test="'marketingAddFilter'"
    >
      +{{ $t('global.actions.add_filter') }}
    </BaseText>
    <Flex :class="$style.wrapper">
      <BaseText
        @click="showCreateModal = true"
        v-test="'onCreateFilterGroup'"
      >
        {{ $t('marketing.email.sections.save_filter_group') }}
      </BaseText>
    </Flex>
  </div>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import FilterLabels from '@/components/customer-filters/FilterLabels.vue';
import CreateFilterGroup from '@/modules/marketing/modals/CreateFilterGroup.vue';
import { useMarketingStore } from '../../store';

export default defineComponent({
  components: {
    FilterLabels,
    CreateFilterGroup,
  },
  setup() {
    const { allFilters } = storeToRefs(useMarketingStore());
    const { toggleFilters, removeFilter } = useMarketingStore();
    return {
      allFilters,
      toggleFilters,
      removeFilter,
    };
  },
  data() {
    return {
      showCreateModal: false,
    };
  },
  methods: {
    onToggleFilters() {
      this.toggleFilters();
    },
    onRemoveFilter(filter) {
      this.removeFilter(filter);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.wrapper {
  border-top: 1px solid var(--color-border);
  margin-top: $spacing;
  padding-top: $spacing;
}
</style>
